export function normalizeReviewPly(ply: number, totalPly: number) {
  const safeTotal = Math.max(0, totalPly);
  const boundedPly = Math.max(0, Math.min(ply, safeTotal));
  return boundedPly >= safeTotal ? null : boundedPly;
}
